/// <field name='as' type='Object'>Assignments object</field>
cafm.hd.as = {

    get tradeListSelector() { return '#' + cafm.res.consts.ElementId_TradeList; },
    get tradePersonListSelector() { return '#' + cafm.res.consts.ElementId_TradePersonList },
    get viewerListSelector() { return '#' + cafm.res.consts.ElementId_ViewerList },
    changedHandlerName: 'cafm.hd.as.onAssignmentsChanged',
    init: function () {
        /// <summary>Assignments initialiser</summary>

    },
    tradeLookupSelected: function (e) {
        /// <summary>Trade added handler</summary>
        /// <param name="e" type="Object">Event args object from lookup</param>

        var id = cafm.util.stringToArray(e.val), vt = $('#tradesPlc');

        // check for any existing matches
        var match = $(cafm.hd.as.tradeListSelector).listViewContains(function (item) {

            return id.indexOf(item.TradeCodeID) > -1;
        });

        // if there's an existing match
        if (match) {

            $('#tradeLookup').clearLookup({ suppressEvents: true, timeout: 500 });
            vt.showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.HDMessageTradeAlreadyAssigned });
            return;
        }

        // create the parent child DTOs
        var dtos = [];
        id.forEach(function (i) {

            dtos.push(cafm.util.createParentChildId(cafm.hd.workOrder.get('ID'), i));
        });

        // if there are valid DTOs
        if (dtos.length) {

            // now make the add trade codes request
            cafm.actions.execute({

                url: cafm.url.api('WorkOrder/AddTradeCodes'),
                values: dtos,
                element: vt[0],
                loaderSelector: '#woAssignments',
                statusCodeFuncs: {

                    200: function (workOrder) {
                        
                        // refresh trade list
                        cafm.hd.as.refreshTradeList();

                        // clear lookup
                        $('#tradeLookup').clearLookup({ suppressEvents: true, timeout: 500 });

                        // call changed handler
                        cafm.handlers.exe(cafm.hd.as.changedHandlerName, workOrder);

                        // ensure add trade person action is shown
                        cafm.hd.as.showAddTradePersonAction();

                        // show success message
                        vt.showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.HDMessageTradeAdded });
                    }
                }
            });
        }
    },
    tradePersonLookupSelected: function (e) {
        /// <summary>Trade person added handler</summary>
        /// <param name="e" type="Object">Events object from lookup</param>

        var tradeId = cafm.lookup.lastCriteria.get('TradeID');

        // quit if there's no trade selected
        if (!tradeId || tradeId == cafm.guid.empty) {

            $('#tradePersonLookup').clearLookup({ suppressEvents: true });
            return false;
        }

        var id = cafm.util.stringToArray(e.val);

        var dtos = [];
        id.forEach(function (i) {
            dtos.push({
                WorkOrderID: cafm.hd.workOrder.get('ID'),
                PersonID: i,
                TradeCodeID: tradeId
            });
        });

        if (dtos.length) {

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/AddTradePeople'),
                values: dtos,
                elementId: 'tradePeoplePlc',
                loaderSelector: '#tradePeoplePlc',
                statusCodeFuncs: {
                    200: function (r) {

                        cafm.handlers.exe(cafm.hd.as.changedHandlerName, r);
                        $('#tradePersonLookup').clearLookup({ suppressEvents: true, timeout: 500 });

                        cafm.hd.as.refreshTradePersonList();
                        cafm.hd.as.refreshViewerList(r);
                        cafm.hd.as.refreshHistoricList(r);

                        $('#tradePeoplePlc').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.HDMessageTradePersonAdded });
                    }
                }
            });
        }
    },
    tradeDataRetrieved: function (r) {
        /// <summary>Checks the trade data, main purpose is to determine if there are trades and whether to display the Trade Persons section</summary>
        /// <param name="r" type="Array">The trades response data</param>
        
        var tradePeopleItem = $('#assignmentsPb .k-item[data-key="{0}"]'.format(cafm.res.consts.DataKey_HelpdeskTradePeople));

        if (!r.length) {

            tradePeopleItem.hide();
            cafm.hd.as.hideAddTradePersonAction();
        }
        else {

            tradePeopleItem.show();
            cafm.hd.as.showAddTradePersonAction();
        }
    },
    onTradePersonLookupLoad: function (e) {
        /// <summary>Trade person lookup load handler, used to setup trade filter</summary>
        /// <param name="e" type="Object">On load args object</param>
        
        var tradeDl = $('#tradeId', e.container).data('kendoDropDownList'),
            tradeFilter = $('#' + cafm.res.consts.ElementId_TradeFilterLookup);

        // this block filters down the trade dropdown items if trades have been filtered already
        if (tradeDl && tradeFilter.length) {

            var filteredTrades = tradeFilter.getLookupSelectedItems();

            if (cafm.util.hasItem(filteredTrades)) {

                var fts = cafm.util.selectValue(filteredTrades, 'value');

                var matchedItems = cafm.util.where(tradeDl.dataSource.data(), function (dataItem) {
                    return cafm.util.arrayContains(fts, dataItem.value);
                });

                tradeDl.dataSource.data(matchedItems);
            }
        }
            // disable the trade drop down if there is only 1 item
        if (tradeDl && tradeDl.dataSource.total() == 1) {

            tradeDl.enable(false);
        }
    },
    validateTradePersonSelection: function(e){

        var c = e.criteria;        
        if (!cafm.util.guidHasValue(c.TradeID) && 
            cafm.nav.isNav(cafm.enums.Navigatable.HelpdeskNewWorkOrder, cafm.enums.Navigatable.HelpdeskEditWorkOrder)) {

            return false;
        }
    },
    tradesToolbar: {
        add: function (e) {
            /// <summary>Add handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            // open the lookup
            cafm.lookup.open('tradeLookup');

            // expand the panel item if collapsed
            cafm.hd.as.helpers.expandPanelItemIfCollapsed(cafm.res.consts.DataKey_HelpdeskTrades);
        },
        remove: function (e) {
            /// <summary>Delete handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            var vt = $('#tradesPlc'), dtos = $(e.target).getListSelectedParentChildArray({ parentId: cafm.hd.workOrder.get('ID'), field: 'TradeCodeID' });

            // check for a selection
            if (!dtos) {

                vt.showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.HDMessageNoTradeSelected });
                return;
            }

            // if there are valid DTOs
            if (dtos.length) {

                // now make the remove trade codes request
                cafm.actions.execute({

                    url: cafm.url.api('WorkOrder/RemoveTradeCodes'),
                    values: dtos,
                    element: vt[0],
                    loaderSelector: '#woAssignments',
                    statusCodeFuncs: {

                        200: function (workOrder) {

                            // refresh trade list
                            cafm.hd.as.refreshTradeList();

                            // refresh trade person list
                            cafm.hd.as.refreshTradePersonList(workOrder);

                            // call changed handler
                            cafm.handlers.exe(cafm.hd.as.changedHandlerName, workOrder);

                            // hide add trade person action if required
                            if (!$('#tradeLv').getListItemCount()) {

                                cafm.hd.as.hideAddTradePersonAction();
                            }

                            // show success message
                            vt.showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageItemsDeleted });
                        }
                    }
                });
            }
        }
    },
    tradePeopleToolbar: {
        add: function (e) {
            /// <summary>Add handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>
            
            // open the lookup
            cafm.lookup.open('tradePersonLookup');

            // expand the panel item if collapsed
            cafm.hd.as.helpers.expandPanelItemIfCollapsed(cafm.res.consts.DataKey_HelpdeskTradePeople);
        },
        remove: function (e) {
            /// <summary>Delete handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            var selIds = $(e.target).getListSelectedParentChildArray({ parentId: cafm.hd.workOrder.get('ID'), field: 'ID' });
            if (!selIds) {
                $('#tradePeoplePlc').showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.HDMessageNoTradePersonSelected });
                return;
            }

            if (selIds.length) {

                cafm.actions.execute({
                    url: cafm.url.api('WorkOrder/RemoveTradePeople'),
                    values: selIds,
                    elementId: 'tradePeoplePlc',
                    loaderSelector: '#tradePeoplePlc',
                    statusCodeFuncs: {
                        200: function (r) {

                            cafm.handlers.exe(cafm.hd.as.changedHandlerName, r);
                            cafm.hd.as.refreshTradePersonList();
                            cafm.hd.as.refreshHistoricList(r);
                            $('#tradePeoplePlc').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageItemsDeleted });
                        }
                    }
                });
            }
        }
    },
    showAddTradePersonAction: function () {

        if (!isMobile) {

            nav.findNavTreeElements('li[data-key="AddTradePerson"]').show();
        }
    },
    hideAddTradePersonAction: function () {
        
        if (!isMobile) {

            nav.findNavTreeElements('li[data-key="AddTradePerson"]').hide();
        }
    },
    onPanelBarSelect: function (e) {

        var item = $(e.item);
        var action = item.data('action');

        if (action) {

            var ce;
            if (e.contentElement) {

                ce = $(e.contentElement);
            }
            else {

                ce = $('> .k-content', item);
            }

            $(ce).loadView({
                url: cafm.url.get(action),
                isForm: false, // set to false as we want to bind and setup the form manually in the onload event of the view
                onLoad: function (taskElement) {
                    
                    // always hide the reassign as only valid once a historic person has been selected
                    var ctrl = isMobile ? $('#historicPeoplePlc .cLvHead', taskElement) : $('[data-key="ReassignPerson"]');
                    ctrl.hide();

                    // bind the work order
                    cafm.hd.bindWorkOrder(cafm.hd.workOrder, $('.bindTarget', taskElement));

                    // setup form elements
                    taskElement.prepareForm();

                    // setup toolbars
                    taskElement.find('.cTb').setupToolbar();

                    // check for removable items
                    cafm.forms.checkForRemovables();
                }
            });
        }
    },
    viewersToolbar: { 
        
        add: function(){

            // open the lookup
            cafm.lookup.open('viewerLookup');
            
            // expand the panel item if collapsed
            cafm.hd.as.helpers.expandPanelItemIfCollapsed(cafm.res.consts.DataKey_HelpdeskViewerPeople);
        },
        remove: function (e) {
            /// <summary>Delete handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            var dtos = $(e.target).getListSelectedParentChildArray({ parentId: cafm.hd.workOrder.get('ID'), field: 'ID' });
            if (!dtos) {

                $('#viewerPeoplePlc').showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.HDMessageNoTradePersonSelected });
                return;
            }

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/RemoveTradePeople'),
                values: dtos,
                elementId: 'viewerPeoplePlc',
                loaderSelector: '#woAssignments',
                statusCodeFuncs: {
                    200: function (r) {

                        cafm.handlers.exe(cafm.hd.as.changedHandlerName, r);
                        cafm.hd.as.refreshViewerList(r);
                        $('#viewerPeoplePlc').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageItemsDeleted });
                    }
                }
            });
        }
    },
    viewerLookupSelected: function (e) {
        /// <summary>Viewer added handler</summary>
        /// <param name="e" type="Object">Events object from lookup</param>

        var id = cafm.util.stringToArray(e.val);

        var dtos = [];
        id.forEach(function (i) {
            dtos.push(cafm.util.createParentChildId(cafm.hd.workOrder.get('ID'), i));
        });
        
        if (dtos.length) {

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/AddViewers'),
                values: dtos,
                elementId: 'viewerPeoplePlc',
                loaderSelector: '#woAssignments',
                statusCodeFuncs: {
                    200: function (r) {

                        cafm.handlers.exe(cafm.hd.as.changedHandlerName, r);
                        cafm.hd.as.refreshViewerList(r);
                        cafm.hd.as.refreshTradePersonList(r);
                        cafm.hd.as.refreshHistoricList(r);
                        $('#viewerLookup').clearLookup({ suppressEvents: true, timeout: 500 });
                        $('#viewerPeoplePlc').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageItemsAdded });
                    }
                }
            });
        }
    },
    onHisoricSelected: function(e){
        
        var count = $('#historicLv').getSelectedItemUids().length;
        var ctrl = $('#historicPeoplePlc .cLvHead, #reassignPersonBtn');

        if (count) {

            ctrl.show();
        }
        else {

            ctrl.hide();
        }
    },
    historicToolbar: {

        reassignperson: function (e) {

            var dtos = $('#historicLv').getListSelectedParentChildArray({ parentId: cafm.hd.workOrder.get('ID'), field: 'ID' });
            if (!dtos) {

                return;
            }

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/ReassignPeople'),
                values: dtos,
                elementId: 'historicPeoplePlc',
                loaderSelector: '#woAssignments',
                statusCodeFuncs: {
                    200: function (r) {

                        cafm.handlers.exe(cafm.hd.as.changedHandlerName, r);
                        cafm.hd.as.refreshTradePersonList(r);
                        cafm.hd.as.refreshHistoricList(r);
                        $('#historicPeoplePlc').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageReassignmentSuccessful });
                    }
                }
            });
        }
    },
    refreshTradeList: function () {

        cafm.util.refreshList({

            list: $(cafm.hd.as.tradeListSelector),
            key: cafm.res.consts.DataKey_HelpdeskTrades,
            isInPanelBar: true
        });
    },
    refreshTradePersonList: function (wo) {
        
        var tl = $(cafm.hd.as.tradePersonListSelector);

        if (tl.length) {

            cafm.util.refreshList({

                list: tl,
                key: cafm.res.consts.DataKey_HelpdeskTradePeople,
                isInPanelBar: true,
                callback: cafm.hd.as.tradePersonListDataRead
            });
        }
        else if (wo) {

            var element = $('[data-key="{0}"]'.format(cafm.res.consts.DataKey_HelpdeskTradePeople));
            var count = wo.TradePeopleCount;
            cafm.hd.setWorkOrderChildCount(element, count, true);
        }
    },
    refreshViewerList: function (wo) {

        var vl = $(cafm.hd.as.viewerListSelector);

        if (vl.length) {

            cafm.util.refreshList({

                list: vl,
                key: cafm.res.consts.DataKey_HelpdeskViewerPeople,
                isInPanelBar: true
            });
        }
        else if(wo) {

            var element = $('[data-key="{0}"]'.format(cafm.res.consts.DataKey_HelpdeskViewerPeople));
            var count = wo.ViewerCount;
            cafm.hd.setWorkOrderChildCount(element, count, true);
        }
    },
    refreshHistoricList: function (wo) {

        var hl = $('#historicLv');

        if (hl.length) {

            cafm.util.refreshList({

                list: hl,
                key: cafm.res.consts.DataKey_HelpdeskHistoricPeople,
                isInPanelBar: true
            });
        }
        else if (wo) {

            var element = $('[data-key="{0}"]'.format(cafm.res.consts.DataKey_HelpdeskHistoricPeople));
            var count = wo.HistoricCount;
            cafm.hd.setWorkOrderChildCount(element, count, true);
        }
    },
    setupSetPrincipalFeature: function () {
        
        $(cafm.hd.as.tradePersonListSelector).on('click', '.principalLock', function (e) {

            var pLock = $(e.currentTarget);

            if (!pLock.data('islocked')) {

                var item = pLock.parents('.tpItem:first');
                cafm.hd.as.setPrincipal(cafm.util.createParentChildId(cafm.hd.workOrder.get('ID'), item.data('id')));
            }
            return false;
        });
    },
    setPrincipal: function (data) {

        cafm.actions.execute({
            url: cafm.url.api('WorkOrder/SetPrincipal'),
            elementId: 'tradePeoplePlc',
            loaderSelector: '#tradePeoplePlc',
            values: data,
            statusCodeFuncs: {
                200: function (r) {

                    var tpLv = $(cafm.hd.as.tradePersonListSelector);
                    $('[data-islocked]', tpLv).removeAttr('data-islocked').removeData('islocked');
                    $('[data-id="{0}"] .principalLock'.format(data.ChildID.ID), tpLv).attr('data-islocked', true);

                    cafm.handlers.exe(cafm.hd.as.changedHandlerName);
                }
            },
            validationMessage: cafm.res.str.HDMessageLabourChargeInvalid
        });
    },
    helpers: {

        expandPanelItemIfCollapsed: function (key) {
            /// <summary>Expand an assignment panel bar item if it's not expanded</summary>
            /// <param name="key" type="String">Panel item key</param>

            var panelLi = $('#assignmentsPb .k-item[data-key="{0}"]'.format(key));
            if (panelLi.attr('aria-expanded') == 'false') {

                setTimeout(function () {

                    panelLi.find('.k-link').click();
                }, 250);
            }
        }
    }
}